<template>
<div>
   <loading :active.sync="loading" 
            :can-cancel="false" 
            :is-full-page="false">Callback</loading>
</div>
</template>

<script>
//import this.HTTP from "../Http";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.min.css";

export default {
  name: "auth-view",
  components: { Loading },
  data: function() {
    return {
      loading: true
    };
  },
  mounted() {
    // if (
    //   this.$route.query.id_token !== null &&
    //   this.$route.query.id_token !== undefined &&
    //   this.$route.query.id_token !== "undefined" &&
    //   this.$route.query.id_token.length > 0 &&
    //   this.$route.query.id_token.indexOf(".") !== -1
    // ) {
    //   this.HTTP.updateHeader(this.$route.query.id_token);
    //   this.$router.push("Changes");
    // }

    console.log(this.HTTP);
    this.HTTP.signinRedirectCallback()
      .then(user => {
        this.HTTP.load().then(() => {

          this.HTTP.post("Users/UpdateUser", 
          {
            idToken: user.id_token,
            accessToken: user.access_token
          }).then(userProfile => {
            console.log(userProfile)
            this.HTTP.setUserProfile(userProfile.data);
            this.$userName = userProfile.data.name;
            window.location.href = "../#/Changes";
          }).
          catch(ex => {

          })
          
        });

        //this.$router.push("Changes");
      })
      .catch(function(err) {
        console.log(err);
      });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/Callback.Vue